import {
    createDocumentAnalysis,
    deleteDocument,
    fetchDocument,
    saveDocument,
    setDocumentMonitoringStatus,
} from '../../../services/DocumentService';

export const FETCH_DOCUMENT = 'FETCH_DOCUMENT';
export const DOCUMENT_EDITING = 'DOCUMENT_EDITING';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const CREATE_DOCUMENT_ANALYSIS = 'CREATE_DOCUMENT_ANALYSIS';
export const SET_DOCUMENT_MONITORING_STATUS = 'SET_DOCUMENT_MONITORING_STATUS';

// ACTION GENERATORS
const fetchDocumentAction = documentId => ({
    type: FETCH_DOCUMENT,
    payload: fetchDocument(documentId),
});

const saveDocumentAction = document => ({
    type: FETCH_DOCUMENT,
    payload: saveDocument(document),
});

const editModeAction = isEditing => ({
    type: DOCUMENT_EDITING,
    payload: isEditing,
});

const deleteDocumentAction = documentId => ({
    type: DELETE_DOCUMENT,
    payload: deleteDocument(documentId),
});

const createDocumentAnalysisAction = (documentId, analysisPriority) => ({
    type: CREATE_DOCUMENT_ANALYSIS,
    payload: createDocumentAnalysis(documentId, analysisPriority),
});

const setDocumentMonitoringStatusAction = (documentId, isMonitored) => ({
    type: SET_DOCUMENT_MONITORING_STATUS,
    payload: setDocumentMonitoringStatus(documentId, isMonitored),
});

// EXPORT ACTIONS
export {
    fetchDocumentAction as fetchDocument,
    saveDocumentAction as saveDocument,
    editModeAction as setDocumentEditMode,
    deleteDocumentAction as deleteDocument,
    createDocumentAnalysisAction,
    setDocumentMonitoringStatusAction,
};
